const localHeaderData = {
  promoBar: {
    text: 'Darmowa dostawa dla zamówień powyżej 199 zł – odkryj naszą ofertę suplementów',
    startDate: '2023-01-01T00:00:00.000Z',
    endDate: '2099-12-31T23:59:59.000Z',
    link: {
      label: 'Sprawdź',
      href: 'https://shop.natu.care/collections'
    },
    variant: 'Default'
  },
  mainBar: {
    logo: {
      href: 'https://natu.care/pl',
      title: 'Natu.Care – Strona główna'
    },
    searchBar: {
      placeholder: 'Czego szukasz?',
      closeLabel: 'Zamknij',
      closeIconName: 'searchClose'
    },
    nav: {
      items: [
        {
          label: 'Black Month',
          href: 'https://shop.natu.care/pages/hub',
          variant: 'red',
          breakpoint: {
            mobile: false,
            desktop: true
          }
        },
        {
          label: 'Black Month',
          href: 'https://shop.natu.care/pages/hub',
          variant: 'buttonPrimary',
          breakpoint: {
            mobile: true,
            desktop: false
          }
        },
        {
          label: 'Sklep',
          href: '#',
          items: {
            products: [
              {
                picture: {
                  src: '/images/skora-wlosy-paznokcie-mobile.jpg',
                  alt: 'Skóra, włosy, paznokcie'
                },
                title: 'Skóra, włosy, paznokcie',
                href: 'https://shop.natu.care/collections#skora-wlosy-i-paznokcie'
              },

              {
                picture: {
                  src: '/images/jelita-i-metabolizm-mobile.jpg',
                  alt: 'Jelita i metabolizm'
                },
                title: 'Jelita i metabolizm',
                href: 'https://shop.natu.care/collections#jelita-i-metabolizm'
              },

              {
                picture: {
                  src: '/images/sylwetka-mobile.jpg',
                  alt: 'Sylwetka'
                },
                title: 'Sylwetka',
                href: 'https://shop.natu.care/collections#ksztaltowanie-sylwetki-cel'
              },

              {
                picture: {
                  src: '/images/balans-i-samopoczucie-mobile.jpg',
                  alt: 'Balans i samopoczucie'
                },
                title: 'Balans i samopoczucie',
                href: 'https://shop.natu.care/collections#balans-i-samopoczucie'
              },

              {
                picture: {
                  src: '/images/odpornosc-mobile.jpg',
                  alt: 'Odporność'
                },
                title: 'Odporność',
                href: 'https://shop.natu.care/collections#odpornosc'
              },

              {
                picture: {
                  src: '/images/witaminy-i-mineraly-mobile.jpg',
                  alt: 'Witaminy i minerały'
                },
                title: 'Witaminy i minerały',
                href: 'https://shop.natu.care/collections#witaminy-i-mineraly'
              }
            ]
          },
          breakpoint: {
            mobile: false,
            desktop: true
          }
        },
        {
          type: 'mobileCategories',
          items: [
              {
                picture: {
                  src: '/images/skora-wlosy-paznokcie-mobile.jpg',
                  alt: 'Skóra, włosy, paznokcie'
                },
                label: 'Skóra, włosy, paznokcie',
                href: 'https://shop.natu.care/collections#skora-wlosy-i-paznokcie'
              },

              {
                picture: {
                  src: '/images/jelita-i-metabolizm-mobile.jpg',
                  alt: 'Jelita i metabolizm'
                },
                label: 'Jelita i metabolizm',
                href: 'https://shop.natu.care/collections#jelita-i-metabolizm'
              },

              {
                picture: {
                  src: '/images/sylwetka-mobile.jpg',
                  alt: 'Sylwetka'
                },
                label: 'Sylwetka',
                href: 'https://shop.natu.care/collections#ksztaltowanie-sylwetki-cel'
              },

              {
                picture: {
                  src: '/images/balans-i-samopoczucie-mobile.jpg',
                  alt: 'Balans i samopoczucie'
                },
                label: 'Balans i samopoczucie',
                href: 'https://shop.natu.care/collections#balans-i-samopoczucie'
              },

              {
                picture: {
                  src: '/images/odpornosc-mobile.jpg',
                  alt: 'Odporność'
                },
                label: 'Odporność',
                href: 'https://shop.natu.care/collections#odpornosc'
              },

              {
                picture: {
                  src: '/images/witaminy-i-mineraly-mobile.jpg',
                  alt: 'Witaminy i minerały'
                },
                label: 'Witaminy i minerały',
                href: 'https://shop.natu.care/collections#witaminy-i-mineraly'
              }            
          ],
          breakpoint: {
            mobile: true,
            desktop: false
          }
        },  

    {
      label: 'Zobacz wszystkie produkty',
      href: 'https://shop.natu.care/collections',
      variant: 'buttonSecondary',
      breakpoint: {
        mobile: true,
        desktop: false
      }
    },   
        {
          label: 'Black Month',
          href: 'https://shop.natu.care/pages/hub',
          variant: 'red',
          breakpoint: {
            mobile: true,
            desktop: false
          }
        },               
        {
          label: 'Opinie',
          href: 'https://natu.care/pl/opinie'
        },
        // {
        //   label: 'Stwórz zestaw',
        //   href: 'https://shop.natu.care/products/stworz-swoj-zestaw'
        // },
        {
          label: 'Dopasuj suplementacje',
          href: 'https://shop.natu.care/pages/quiz-dopasuj-suplementacje'
        }        
      ]
    },
    headerItemsCollection: [
      {
        type: 'search',
        label: 'Szukaj',
        title: 'Szukaj',
        breakpoint: {
          desktop: true,
          mobile: true
        }
      },
      {
        type: 'account',
        label: 'Konto',
        title: 'Zaloguj się',
        href: 'https://shop.natu.care/account/login',
        breakpoint: {
          desktop: true,
          mobile: true
        }
      },
      {
        type: 'bag',
        label: 'Torba',
        title: 'Torba',
        href: 'https://shop.natu.care/collections?viewcart=true',
        breakpoint: {
          desktop: true,
          mobile: true
        }
      }
    ]
  },
  initialSearch: {
    products: {
      label: 'Sklep',
      id: null
    }
  }
};

module.exports = localHeaderData;
module.exports.default = localHeaderData;
